export default {
      id: "i-play-usage",
      viewBox: "0 0 29 32",
      url: __webpack_public_path__ + "img/sprite.svg#i-play",
      toString: function () {
        return this.url;
      }
    }